import $ from 'jquery';

$(function () {
    if ($('#partner_home_page').length) {
        $(window).on('resize', function () {
        });
        var $managerProfile = $('.leadership-profile');
        var $cmgProfile = $('#partner_home_page');
        var $imgPrefix = "https://res.cloudinary.com/dvbdysuf5/image/upload/q_auto,f_auto/CMG_Web_Resources/JVPortal_Images/HomePage_Images";
        $('#l1').on('click', function (e) {
            showL1()
        });
        $('#l11').on('click', function (e) {
            showL1()
        });
        $('#l2').on('click', function (e) {
            showL2()
        });
        $('#l12').on('click', function (e) {
            showL2()
        });
        $('#l3').on('click', function (e) {
            showL3()
        });
        $('#l13').on('click', function (e) {
            showL3()
        });
        $('#l4').on('click', function (e) {
            showL4()
        });
        $('#l14').on('click', function (e) {
            showL4()
        });
        $('#l5').on('click', function (e) {
            showL5()
        });
        $('#l15').on('click', function (e) {
            showL5()
        });
        function showL1() {
            $('#img-div').css('display', 'none');
            $('#video-div').css('display', 'block');
            $managerProfile.addClass('show');
            $cmgProfile.addClass('blured');
            $('#managerprofile-img').attr('src', $imgPrefix + '/Chris_George_Headshot.png');
            $('#managerprofile-name').text('Chris George');
            $('#managerprofile-title').text('CEO & Founder');
            $('#managerprofile-desc').html('<p>As businesses scale, many leaders make the mistake of growing just for growth’s sake. Christopher M. George has grown his business from a garage to a national brand because of his ability to grow efficiently and scale effectively. Since 1993, Christopher M. George has been a champion for the lender and the consumer.</p><p>He is an advocate for responsible lending practices and regulation. In addition to serving as the President and CEO of CMG Financial, Christopher M. George was the 2019 Chairman of the Mortgage Bankers Association. He understands that the best way to succeed in an industry is to influence it. </p><p>CMG Financial continues to thrive after 20+ years under his inspirational guidance. As a direct lender, CMG Financial has the advantage of developing and launching proprietary products like the All In One Loan™ and HomeFundIt™. The All In One Loan combines banking and mortgage financing to allow homeowners to apply payments to principal balance first, lowering the lifetime cost of mortgage interest, and paying off their mortgage faster. HomeFundIt is the first and only crowdfunding platform designed specifically for the down payment on a home. </p>');
            $('#v-thumbnail').css('background-image', `url(${$imgPrefix + '/Video_Square.png'})`);
            $('#v-url').attr('href', 'https://player.vimeo.com/video/190641310');
        }
        function showL2() {
            $('#img-div').css('display','block');
            $('#video-div').css('display', 'none');
            $managerProfile.addClass('show');
            $cmgProfile.addClass('blured');
            $('#managerprofile-img').attr('src', $imgPrefix + '/Kim_Callas_Headshot.png');
            $('#managerprofile-name').text('Kim Callas');
            $('#managerprofile-title').text('CEO & Founder');
            $('#managerprofile-desc').html('<p>Kimberly Callas has spent more than twenty years developing operational efficiencies, risk management policies and procedures and customer service best practices, while supporting and guiding sales opportunities across all areas of mortgage lending, including Correspondent, Wholesale and Retail Lending production. Callas currently serves as CMG Financial Executive Vice President, as well as oversees all sales and fulfillment activity for the Retail Lending business channel.</p>');
            $('#img-div-image').attr('src', $imgPrefix + '/kim-Callas-profile.png');
        }
        function showL3() {
            $('#img-div').css('display', 'none');
            $('#video-div').css('display', 'block');
            $managerProfile.addClass('show');
            $cmgProfile.addClass('blured');
            $('#managerprofile-img').attr('src', $imgPrefix + '/Charlie_Rogers_Headshot.png');
            $('#managerprofile-name').text('Charlie Rogers');
            $('#managerprofile-title').text('SVP');
            $('#managerprofile-desc').html('<p>Charlie Rogers serves as CMG Financial’s Senior Vice President of Retail Lending. Rogers has more than 20 years of experience in the banking and mortgage industry with loan process and pipeline management, recruiting, and developing productive originators. He has held prestigious positions including President, CEO, Managing Director, Regional Vice President, and Executive Vice President at his previous companies. Rogers will support the Retail Lending division by guiding its growth, stability, and reputation nationwide while upholding the CMG Financial.</p>');
            $('#v-thumbnail').css('background-image', `url(${$imgPrefix + '/Video_Square.png'})`);
            $('#v-url').attr('href', 'https://player.vimeo.com/video/187383160');
        }
        function showL4() {
            $('#img-div').css('display', 'none');
            $('#video-div').css('display', 'block');
            $managerProfile.addClass('show');
            $cmgProfile.addClass('blured');
            $('#managerprofile-img').attr('src', $imgPrefix + '/Chris_Harris_Headshot.png');
            $('#managerprofile-name').text('Chris Harris');
            $('#managerprofile-title').text('VP National JV Manager');
            $('#managerprofile-desc').html('<p>Chris is an accomplished executive sales leader with over 16 years of experience developing corporate partnerships, managing joint ventures and leveraging relationships to gain valuable market share. “Partnerships are important to me, they are how top companies become industry-leading organizations,” Chris Harris said in a statement, “Throughout my career I’ve demonstrated the ability to build lasting relationships and establish joint venture partnerships and I look forward to continuing to do so with CMG Financial.”</p>');
            $('#v-thumbnail').css('background-image', `url(${$imgPrefix + '/Video_Square.png'})`);
            $('#v-url').attr('href', 'https://player.vimeo.com/video/402298122');
        }
        function showL5() {
            $('#img-div').css('display', 'none');
            $('#video-div').css('display', 'block');
            $managerProfile.addClass('show');
            $cmgProfile.addClass('blured');
            $('#managerprofile-img').attr('src', $imgPrefix + '/Sara_Reed_Headshot.png');
            $('#managerprofile-name').text('Sara Reed');
            $('#managerprofile-title').text('VP Operations');
            $('#managerprofile-desc').html('<p>Sara Reed has worked with CMG Financial since 2004, holding a range of positions including loan processor, DE underwriter, account manager, national branch development liaison and branch development and national support manager. Currently, she is the Vice President of Operations. Sara also plays a significant role in new program rollout and special projects, including HomeFundIt and Joint Ventures. Her depth of understanding of CMG Financial Operations combined with her critical problem-solving skills enable her to implement efficient strategy and pursue operational excellence. Sara is an alumni of Golden Gate University in San Francisco and enjoys spending time at the ballpark with her husband and two sons.</p>');
            $('#v-thumbnail').css('background-image', `url(${$imgPrefix + '/Video_Square.png'})`);
            $('#v-url').attr('href', 'https://player.vimeo.com/video/469826634');
        }
        $managerProfile.on('click', '.close-btn', function (e) {
            $managerProfile.removeClass('show');
            $cmgProfile.removeClass('blured');
        });
    }

    function renderCustomSelect() {
        if (window.screen.width  < 768) {
            return;
        }

        var $customSelect = $('.team-selector');
        if ($customSelect.find('div').length > 0)
            return;

        var $selectedItem = $(`<div class="selected-item"><span class="selected-text"></span><span class="arrow"><i class="fas fa-angle-down"></i></span></div>`);
        $selectedItem.appendTo($customSelect);

        var $optionContainer = $('<div class="select-items select-hide"></div>');
        $customSelect.find('select option').each(function (index, elem) {
            var $item = $(`<div class=${index === 0 ? "same-as-selected" : ""}>${elem.innerHTML}</div>`);
            $item.on('click', function (e) {
                $optionContainer.find('.same-as-selected').removeClass('same-as-selected');
                $(this).addClass('same-as-selected');
                $selectedItem.find('.selected-text').text(elem.innerHTML);

                $('.team-container').removeClass('show');
                $(`#${elem.value}`).addClass('show');

                closeSelect(e);
            });
            $item.appendTo($optionContainer);

            if (index === 0) {
                $selectedItem.find('.selected-text').text(elem.innerHTML);
                $(`#${elem.value}`).addClass('show');
            }
        });
        $optionContainer.appendTo($customSelect);

        $customSelect.find('.selected-item').on('click', function (e) {
            closeSelect(e);
        });

        $('body').on('click', function (e) {
            if ($selectedItem.hasClass("select-arrow-active")) {
                closeSelect(e);
            }
        });

        function closeSelect(event) {
            event.stopPropagation();
            $optionContainer.toggleClass("select-hide");
            $selectedItem.toggleClass("select-arrow-active");
        }
    }
});